export const exportToCSV = (data, filename = 'export') => {
  if (!data || data.length === 0) {
    console.warn('No data to export');
    return;
  }

  // get all unique keys from all objects
  const allKeys = Array.from(
    new Set(data.flatMap(item => Object.keys(item)))
  );

  // create CSV header row
  const headers = allKeys.join(',');

  // create CSV data rows
  const rows = data.map(item => {
    return allKeys.map(key => {
      let value = item[key];

      // handle null/undefined
      if (value === null || value === undefined) {
        return '';
      }

      // convert to string
      value = String(value);

      // escape quotes and wrap in quotes if contains comma, quote, or newline
      if (value.includes(',') || value.includes('"') || value.includes('\n')) {
        value = `"${value.replace(/"/g, '""')}"`;
      }

      return value;
    }).join(',');
  });

  // combine headers and rows
  const csv = [headers, ...rows].join('\n');

  // create blob and download
  const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
  const link = document.createElement('a');
  const url = URL.createObjectURL(blob);

  link.setAttribute('href', url);
  link.setAttribute('download', `${filename}.csv`);
  link.style.visibility = 'hidden';

  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);

  // clean up
  URL.revokeObjectURL(url);
};